import React from 'react';
import { SocialProof } from './SocialProof';
import { Bonuses } from './Bonuses';
import { Pricing } from './Pricing';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
export function FacebookLander() {
  return <div className="min-h-screen font-sans text-gray-900 bg-[#F0F2F5] selection:bg-brand-pink selection:text-brand-dark pt-[72px]" data-id="element-120">
      {/* Facebook Post Style Hero */}
      <div className="pt-4 pb-8" data-id="element-121">
        <SocialProof data-id="element-122" />
      </div>

      {/* Bonuses Section - White background to separate */}
      <div className="bg-white" data-id="element-123">
        <Bonuses data-id="element-124" />
      </div>

      {/* Pricing/Offer Section */}
      <div className="bg-white" data-id="element-125">
        <Pricing data-id="element-126" />
      </div>

      {/* FAQ Section */}
      <div className="bg-white" data-id="element-127">
        <FAQ data-id="element-128" />
      </div>

      {/* Final Close Section */}
      <section className="bg-brand-dark text-white py-20 px-4 text-center" data-id="element-129">
        <div className="max-w-2xl mx-auto" data-id="element-130">
          <h2 className="text-3xl font-bold mb-6" data-id="element-131">
            Tu primera venta no te cambia solo el bolsillo… <br data-id="element-132" />
            <span className="text-brand-pink" data-id="element-133">te cambia la cabeza.</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-134">
            Porque después de esa primera venta, ya no eres "una mamá que
            quiere". Eres una mamá que{' '}
            <span className="font-bold text-white" data-id="element-135">puede</span>.
          </p>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-pink hover:bg-rose-400 text-brand-dark font-bold py-4 px-8 rounded-full text-xl transition-all transform hover:-translate-y-1" data-id="element-136">
            Descargar Mamá Digital 2.0 ahora
          </button>
        </div>
      </section>

      <Footer data-id="element-137" />
    </div>;
}